import { AuthService } from "../../../services/auth/auth.service";
import { RastreamentoService } from "../../../services/rastreamento/rastreamento.service";

export class RastreamentoDetalhesController {
  /**
   * @param {AuthService} Auth
   * @param {RastreamentoService} Rastreamento
   * @param {ClienteApiService} ClienteService
   */

  constructor(Auth, Rastreamento, $mdToast) {
    "ngInject";

    this.Auth = Auth;
    this.Rastreamento = Rastreamento;
    this.Toast = $mdToast;
    this.getDadosVolumes();

    this.loading = false;
    this.detalhes = [];
    this.url = '';
  }

  isLoggedIn() {
    return this.Auth.isLoggedIn();
  }

  visualizarComprovante(url) {
    var currentUser = JSON.parse(localStorage.getItem('ls.user')).email;

    gtag('event', 'click', {'event_category': 'button', 'event_label': 'comprovante_entrega', 'data': currentUser});

    window.open(url);
  }

  async getDadosVolumes() {
    this.loading = true;
    await this.encomenda;
    if(this.encomenda) {
      this.Rastreamento.getDadosVolumes(this.encomenda.codigoRastreamento).then(response => {
        this.detalhes = response;
      });

      this.getComprovante();
    }
    this.loading = false;
  }

  async getComprovante() {
      this.Rastreamento.getComprovanteEntrega(
       this.encomenda.id
     ).then(response => {
      this.url = response.url;
     }).catch(error => {
       console.log('eee', error);
     })
  }

  async sendEmail() {
    const properties = {
      nomeDestinatario: this.encomenda.destinatario.nome,
      emailDestinatario: this.encomenda.destinatario.email,
      nomeRemetente: this.encomenda.remetente.nome,
      emailRemetente: this.Auth.getCurrentUser().email,
      codigoRastreamento: this.encomenda.codigoRastreamento,
      url: URL + "/rastreamento/" + this.encomenda.codigoRastreamento
    };

    var toast;
    try {
      await this.Rastreamento.putEmailDestinatario({
        codigoRastreamento: properties.codigoRastreamento,
        novoEmail: properties.emailDestinatario
      });

      toast = this.Toast.simple()
        .textContent("Email atualizado com sucesso")
        .position("bottom center")
        .action("OK");
    } catch (_) {
      toast = this.Toast.simple()
        .textContent(
          "Não foi possível atualizar o email, por favor tente novamente."
        )
        .position("bottom center")
        .action("OK");
    }

    this.Toast.show(toast);
  }
}
